import React from 'react';

import Typography from '../../../components/Typography';
import Image from '../../../components/Image';

import bahianinho_mobile from '../../../assets/images/bahianinho_mobile.png';
import bahianinho from '../../../assets/images/bahianinho.png';

import closeIcon from '../../../assets/svg/closeIcon.svg';
import facebook from '../../../assets/svg/facebook.svg';
import hamburgerIcon from '../../../assets/svg/hamburguer.svg';
import logo from '../../../assets/svg/horizontalLogo.svg';
import instagram from '../../../assets/svg/instagram.svg';
import linkedin from '../../../assets/svg/linkedin.svg';
import youtube from '../../../assets/svg/youtube.svg';

import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

interface MaintenanceProps {
  maintenance: boolean;
}

const Maintenance = ({ maintenance }: MaintenanceProps) => {
  function handleClick() {
    window.location.href = 'https://marketplace.via.com.br/';
  }

  return (
    <>
      <Header
        logo={logo}
        closeIcon={closeIcon}
        hamburgerIcon={hamburgerIcon}
        hasRecord="Já tem cadastro?"
        login="Faça seu login"
        maintenance={maintenance}
      />
      <div className="mt-12 mx-auto grid items-center justify-center grid-cols-[20%_37%] max-[1023px]:grid-cols-[100%] max-[1023px]:mx-5 max-[1023px]:mt-12 lg:max-[1439px]:grid-cols-[24.5%_55%]">
        <div className="grid gap-y-6 mb-[2.625rem] max-[1023px]:justify-items-start max-[1023px]:mb-[0.625rem]">
          <div>
            <Typography as="h2" className="text-[28px] leading-[48px] font-semibold text-primary">
              Voltamos em breve!
            </Typography>
          </div>
          <div className="w-[85%]">
            <Typography variant="body2" className="mb-[22px] text-neutral-dark">
              Estamos evoluindo alguns pontos em nosso website e ficaremos em manutenção nas
              próximas horas.
            </Typography>
          </div>
          <div className="w-[85%]">
            <Typography variant="body2" className="text-neutral-dark">
              Enquanto isso, que tal descobrir um pouco mais sobre a Via?
            </Typography>
          </div>
          <div>
            <span
              className="font-semibold text-sm leading-6 cursor-pointer text-primary"
              onClick={handleClick}
            >
              Conheça nosso site
            </span>
          </div>
        </div>
        <div className="hidden max-[1023px]:grid justify-center mt-[0.625rem]">
          <Image images={[{ img: `${bahianinho_mobile}`, alt: 'marketplace-logo-mobile' }]} />
        </div>
        <div className="grid justify-center max-[1023px]:hidden">
          <Image images={[{ img: `${bahianinho}`, alt: 'marketplace-logo' }]} />
        </div>
      </div>
      <Footer
        logo={logo}
        instagramSvg={instagram}
        youtubeSvg={youtube}
        facebookSvg={facebook}
        linkedinSvg={linkedin}
        titleSocialMedias="Acompanhe a gente"
        legalText="Grupo Casas Bahia S.A. - CNPJ: 33.041.260/0652-90 - Rua Florida, 1970 - São Paulo - SP - CEP: 04565-001"
        FrequentQuestions="Dúvidas frequentes"
        FrequentQuestionsLink="https://suportemarketplace.viavarejo.com.br/pt-BR/lojista/"
      />
    </>
  );
};

export default Maintenance;
